<template>
  <div :class="{ line: isLine }">
    <a
      v-if="actions.length"
      class="icon-dot"
      href="javascript:;"
      @click.stop="show = true"
    >
      <i class="dot-item"></i>
      <i class="dot-item"></i>
    </a>
  </div>
  <van-action-sheet
    v-model:show="show"
    :actions="actions"
    cancel-text="取消"
    close-on-click-action
    @cancel="onCancel"
    @select="onSelect"
  />
</template>
<script>
  import store from '@/store'
  import storage from '@/utils/storage'
  import { Toast } from 'vant'
  export default {
    props: {
      // list: {
      //   type: Array,
      //   default() {
      //     return []
      //   },
      // },
      data: {
        type: Object,
        default() {
          return {}
        },
      },
      isLine: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['delDone'],
    data() {
      return {
        loginUserId: store.getters['user/getUserInfo'].UserId,
        show: false,
        actions: [],
      }
    },
    mounted() {
      if (this.loginUserId === this.data.CreatedBy && this.data.Status != 3) {
        this.actions.push({ name: '编辑' })
        this.actions.push({ name: '删除' })
      }
      if (this.data.Status == 3) {
        this.actions.unshift({ name: '生成图片' })
      }
    },
    methods: {
      onCancel() {
        //Toast('取消')
      },
      onSelect(item) {
        if (item.name == '编辑') {
          this.$router.push({
            name: 'CaseAdd',
            query: {
              id: this.data.Id,
            },
          })
        }
        if (item.name == '删除') {
          this.del(this.data.Id)
        }
        if (item.name == '生成图片') {
          this.$go('CaseToImg', {
            params: {
              id: this.data.Id,
            },
          })
        }
      },
      del(id) {
        store
          .dispatch('case/PostDelete', {
            Id: id,
          })
          .then(() => {
            Toast.success('删除成功')
            setTimeout(() => {
              this.$emit('delDone', '')
              //this.list.splice(this.index, 1)
            }, 300)
          })
          .catch((e) => {
            Toast.success('删除失败')
          })
      },
    },
  }
</script>
<style lang="scss" scoped>
  .icon-dot {
    width: 30px;
    height: 30px;
    // background: #f00;
    position: relative;
    &.line {
      transform: rotate(90deg) translateX(-1px);
    }
    .dot-item {
      position: absolute;
      width: 4px;
      height: 4px;
      background: #454976;
      border-radius: 50%;
      top: 50%;
      margin-top: -2px;
      left: 50%;
      margin-left: -6px;
      &:last-child {
        margin-left: 2px;
      }
    }
  }
</style>
